import { render, staticRenderFns } from "./VoucherWord.vue?vue&type=template&id=39a73b48"
import script from "./VoucherWord.vue?vue&type=script&lang=js"
export * from "./VoucherWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports